import React from 'react'
import ErrorPage from 'features/errors/ui/ErrorPage'
import { ApiError } from 'features/common'

type Props = {
  children: React.ReactNode
  hasError?: ApiError | null
}

export const CustomErrorBoundary = function (props: Props) {
  if (props.hasError) {
    return <ErrorPage code="500" />
  } else {
    return <React.Fragment>{props.children}</React.Fragment>
  }
}
